export default __webpack_public_path__ + "static/media/12wbtlogowhite.0011e411.png";